import { Input } from "antd";
import React from "react";

const SearchComponent = ({
  placeholder,
  width,
  disabled,
  handleSearch,
}: {
  handleSearch: Function;
  placeholder?: string;
  width?: string;
  disabled?: boolean;
}) => {
  const onChange = (e: any) => {
    if (e.target.value === "") {
      handleSearch("");
    }
  };
  const onSearch = (value: string) => {
    handleSearch(value);
  };

  return (
    <Input.Search
      placeholder={placeholder || "Search"}
      allowClear
      onChange={onChange}
      onSearch={onSearch}
      className={width || "w-[264px]"}
      disabled={disabled || false}
    />
  );
};

export default SearchComponent;
